module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibCommission-box"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("\n      " + _vm._s(_vm.ibCommissionLan.ibAccount) + " : " + _vm._s(_vm.$route.query.id) + "    " + _vm._s(_vm.ibCommissionLan.ibcAccount) + " : " + _vm._s(_vm.$route.query.ibc) + "\n      "), (_vm.showPreview) ? _c('span', [_vm._v(" - " + _vm._s(_vm.ibCommissionLan.btnGroup.commissionPreviewBtn))]) : _vm._e()]), _vm._v(" "), (!_vm.showPreview) ? _c('div', {
    staticClass: "pull-right viewBtn-box"
  }, [_c('button', {
    staticClass: "double",
    on: {
      "click": function($event) {
        _vm.viewBtn = 'double'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v("\n        " + _vm._s(_vm.ibCommissionLan.contrastBrowse) + "\n      ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.viewBtn = 'onlyOne'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-list-alt"
  }), _vm._v("\n        " + _vm._s(_vm.ibCommissionLan.singlepageBrowse) + "\n      ")])]) : _vm._e(), _vm._v(" "), (!_vm.showPreview) ? _c('button', {
    staticClass: "pull-right preview-btn",
    on: {
      "click": function($event) {
        _vm.showPreview = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.ibCommissionLan.btnGroup.commissionPreviewBtn) + "\n    ")]) : _c('button', {
    staticClass: "pull-right preview-btn",
    on: {
      "click": function($event) {
        _vm.showPreview = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.ibCommissionLan.btnGroup.back) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), (_vm.showPreview) ? _c('ib-commission-preview', {
    attrs: {
      "region": _vm.$route.query.region,
      "ibCommissionLan": _vm.ibCommissionLan
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showPreview) ? _c('div', {
    staticClass: "content-box"
  }, [(_vm.viewBtn == 'double') ? _c('div', {
    staticClass: "version0",
    class: {
      'doubleView margin-right': _vm.viewBtn === 'double'
    }
  }, [_c('ib-commission-setting-content', {
    ref: "version0",
    attrs: {
      "multiLanguage": _vm.ibCommissionLan,
      "version": '0',
      "curArea": _vm.curArea,
      "viewBtn": _vm.viewBtn
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "version1",
    class: {
      'doubleView': _vm.viewBtn === 'double'
    }
  }, [_c('ib-commission-setting-content', {
    ref: "version1",
    attrs: {
      "multiLanguage": _vm.ibCommissionLan,
      "version": '1',
      "viewBtn": _vm.viewBtn,
      "curArea": _vm.curArea
    },
    on: {
      "afterVerify": _vm.afterVerifyFn
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-055df168","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/IB/IBSetting/ibCommissionSetting.vue
// module id = 1067
// module chunks = 1